import React from 'react';
import './assets/css/fonts.css'
import {ThemeProvider} from '@mui/material/styles';
import CustomTheme from './assets/CustomTheme';
import rtlPlugin from 'stylis-plugin-rtl';
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import {prefixer} from 'stylis';
import {RepairRequest} from './RepairRequest';
import {SimpleRepairRequest} from './SimpleRepairRequest';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import {Success} from "./Success";

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

function App() {
    return (
        <ThemeProvider theme={CustomTheme}>
            <CacheProvider value={cacheRtl}>
                <Router>
                    <Switch>
                        {/*<Route exact path="/">*/}
                        {/*    <RepairRequest/>*/}
                        {/*</Route>*/}
                        <Route path="/RepairRequest">
                            <RepairRequest/>
                        </Route>
                        <Route path="/SimpleRepairRequest">
                            <SimpleRepairRequest/>
                        </Route>
                        <Route path="/Success">
                            <Success/>
                        </Route>
                    </Switch>
                </Router>
            </CacheProvider>
        </ThemeProvider>
    );
}

export default App;
